import { createElement } from "react";

const getTestId = (...props: (string | number)[]) =>
  props
    .map((value) =>
      String(value)
        .replace(/([a-z0-9])([A-Z])/g, '$1-$2')
        .replace(/^\[+/, '')
        .replace(/\]+$/, '')
        .replace(/[\[\]]+/g, '-')
        .replace(/[.\s]+/g, '-')
        .toLowerCase()
    )
    .join('-');

export const createLabelWithtestId = (text: string, dataTestId: string, element = 'span') =>
  createElement(element, { 'data-test': dataTestId }, text) as unknown as string;

export default getTestId;